export default "__VITE_ASSET__CeqxtEXl__"